export default function () {
  const isEmbeddedCheckout = ref(false)

  return {
    isEmbeddedCheckout: computed(() => isEmbeddedCheckout.value),
  }
}
